import { PureComponent } from 'react';
import { View, Image, TouchableOpacity } from 'react-native';
import { Text, Popup, Button, TextInput, LabelledView, Label } from '@symbolic/rn-lib';
import { connect } from '@symbolic/redux';
import { resourceActions } from '~/redux';

import _ from 'lodash';
import trashIcon from '~/assets/trash-icon.png';

import K from '~/k';

class ProductOptionClassifierPopup extends PureComponent {
  state = {
    localNumbers: Array.isArray(this.props.productOptionClassifier?.numbers)
      ? this.props.productOptionClassifier.numbers
      : [],
  };

  constructor(props) {
    super(props);
  }

  close = () => {
    this.props.onClose();
  };

  handleTitleChange = ({value}) => this.props.updateProductOptionClassifier({id: this.props.productOptionClassifier.id, props: {title: value}});

  handleDelete = async () => {
    if (await confirm('Are you sure you want to delete this classifier?')) {
      this.props.updateProductOptionClassifier({id: this.props.productOptionClassifier.id, props: {deleted: 1}});
      this.close();
    }
  };

  componentDidUpdate(prevProps) {
    if (prevProps.productOptionClassifier?.numbers !== this.props.productOptionClassifier?.numbers) {
      this.setState({
        localNumbers: Array.isArray(this.props.productOptionClassifier?.numbers)
          ? this.props.productOptionClassifier.numbers
          : []
      });
    }
  }

  handleDateChange = (versionIndex, value) => {
    const updatedLocalNumbers = [...this.state.localNumbers];
    updatedLocalNumbers[versionIndex] = {
      ...updatedLocalNumbers[versionIndex],
      date: value
    };

    this.setState({ localNumbers: updatedLocalNumbers });

    this.props.updateProductOptionClassifier({
      id: this.props.productOptionClassifier.id,
      props: { numbers: updatedLocalNumbers }
    });
  };

  handleNumberChange = (versionIndex, rowIndex, value) => {
    const updatedLocalNumbers = [...this.state.localNumbers];
    const version = updatedLocalNumbers[versionIndex];
    const updatedNumbers = [...(version.numbers || [])];

    updatedNumbers[rowIndex] = parseFloat(value) || 0;

    updatedLocalNumbers[versionIndex] = {
      ...version,
      numbers: updatedNumbers
    };

    this.setState({ localNumbers: updatedLocalNumbers });

    // Update database
    this.props.updateProductOptionClassifier({
      id: this.props.productOptionClassifier.id,
      props: { numbers: updatedLocalNumbers }
    });
  };

  handleDescriptionChange = (versionIndex, rowIndex, value) => {
    const updatedLocalNumbers = [...this.state.localNumbers];
    const version = updatedLocalNumbers[versionIndex];
    const descriptions = Array.isArray(version.description)
      ? version.description
      : _.split(version.description || '', ',');

    const updatedDescriptions = [...descriptions];
    updatedDescriptions[rowIndex] = value;

    updatedLocalNumbers[versionIndex] = {
      ...version,
      description: updatedDescriptions.join(',')
    };

    this.setState({ localNumbers: updatedLocalNumbers });

    this.props.updateProductOptionClassifier({
      id: this.props.productOptionClassifier.id,
      props: { numbers: updatedLocalNumbers }
    });
  };

  handleDeleteRow = async (versionIndex, rowIndex) => {
    if (await confirm('Are you sure you want to delete this number and description?')) {
      const updatedLocalNumbers = [...this.state.localNumbers];
      const version = updatedLocalNumbers[versionIndex];

      const updatedNumbers = [...(version.numbers || [])];
      updatedNumbers.splice(rowIndex, 1);

      const descriptions = Array.isArray(version.description)
        ? version.description
        : _.split(version.description || '', ',');

      const updatedDescriptions = [...descriptions];
      updatedDescriptions.splice(rowIndex, 1);

      updatedLocalNumbers[versionIndex] = {
        ...version,
        numbers: updatedNumbers,
        description: updatedDescriptions.join(',')
      };

      this.setState({ localNumbers: updatedLocalNumbers });

      this.props.updateProductOptionClassifier({
        id: this.props.productOptionClassifier.id,
        props: { numbers: updatedLocalNumbers }
      });
    }
  };

  handleAddRow = (versionIndex) => {
    const updatedLocalNumbers = [...this.state.localNumbers];
    const version = updatedLocalNumbers[versionIndex];

    const updatedNumbers = [...(version.numbers || []), 0];

    const descriptions = Array.isArray(version.description)
      ? version.description
      : _.split(version.description || '', ',');

    const updatedDescriptions = [...descriptions, ''];

    updatedLocalNumbers[versionIndex] = {
      ...version,
      numbers: updatedNumbers,
      description: updatedDescriptions.join(',')
    };

    this.setState({ localNumbers: updatedLocalNumbers });

    this.props.updateProductOptionClassifier({
      id: this.props.productOptionClassifier.id,
      props: { numbers: updatedLocalNumbers }
    });
  };

  deleteVersion = async (versionIndex) => {
    if (await confirm('Are you sure you want to delete this version?')) {
      const updatedLocalNumbers = [...this.state.localNumbers];
      updatedLocalNumbers.splice(versionIndex, 1);

      this.setState({ localNumbers: updatedLocalNumbers });

      this.props.updateProductOptionClassifier({
        id: this.props.productOptionClassifier.id,
        props: { numbers: updatedLocalNumbers }
      });
    }
  };

  createProductOptionClassifierNumbersVersion = () => {
    const now = new Date();
    const formattedDate = now.toISOString().slice(0, 19).replace('T', ' ');

    const updatedLocalNumbers = [
      ...this.state.localNumbers,
      {
        date: formattedDate,
        numbers: [],
        description: ''
      }
    ];

    this.setState({ localNumbers: updatedLocalNumbers });

    this.props.updateProductOptionClassifier({
      id: this.props.productOptionClassifier.id,
      props: { numbers: updatedLocalNumbers }
    });
  };

  render() {
    const {productOptionClassifier, mode} = this.props;

    return (
      <Popup onClose={this.close}>
        {mode === 'admin' && (
          <View>
            <TextInput
              style={{...K.fonts.pageHeader, paddingHorizontal: K.spacing, paddingTop: 0, backgroundColor: 'white', marginTop: K.spacing, marginBottom: K.spacing}}
              value={productOptionClassifier.title}
              onChange={({value}) => this.handleTitleChange({value})}
              blurOnEnter
              blurOnSubmit
              multiline
              standardAutoheightStyles
              returnKeyType='done'
            />
            <LabelledView label={'Versions'} styles={{innerView: {marginBottom: K.margin}, outerView: {marginBottom: K.spacing}}}>
              {_.map(this.state.localNumbers, (version, versionKey) => {
                const numbers = version.numbers || [];
                const descriptions = Array.isArray(version.description)
                  ? version.description
                  : _.split(version.description || '', ',');

                return (
                  <View
                    key={versionKey}
                    style={{
                      marginBottom: K.margin,
                      padding: K.margin,
                      borderColor: 'rgba(0, 0, 0, 0.2)',
                      borderWidth: 1,
                      borderRadius: K.borderRadius,
                      borderStyle: 'solid'
                    }}
                  >
                    <LabelledView gray label={'Effective Date (UTC)'} styles={{outerView: {marginBottom: K.margin}}}>
                      <TextInput
                        value={version.date || ''}
                        onChange={({value}) => this.handleDateChange(versionKey, value)}
                        placeholder="YYYY-MM-DD HH:MM:SS"
                      />
                    </LabelledView>

                    {/* Header Row */}
                    <View style={{flexDirection: 'row', marginBottom: K.margin}}>
                      <Label style={{flex: 1, marginRight: K.margin, paddingLeft: K.spacing}}>Description</Label>
                      <Label style={{width: 100, marginRight: K.margin, paddingLeft: K.spacing}}>Number</Label>
                      <View style={{width: 16}} />
                    </View>

                    {/* Data Rows */}
                    {_.map(numbers, (number, index) => (
                      <View key={index} style={{flexDirection: 'row', marginBottom: K.margin, alignItems: 'center'}}>
                        <TextInput
                          value={_.trim(descriptions[index]) || ''}
                          onChange={({value}) => this.handleDescriptionChange(versionKey, index, value)}
                          placeholder="Description"
                          style={{flex: 1, marginRight: K.margin}}
                        />
                        <TextInput
                          value={String(number || '')}
                          onChange={({value}) => this.handleNumberChange(versionKey, index, value)}
                          placeholder="0"
                          style={{width: 100, marginRight: K.margin}}
                        />
                        <TouchableOpacity
                          onPress={() => this.handleDeleteRow(versionKey, index)}
                        >
                          <Image source={trashIcon} style={{...K.defaultIconSize, opacity: 0.5}} />
                        </TouchableOpacity>
                      </View>
                    ))}

                    <View style={{flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', marginTop: K.margin}}>
                      <Button
                        label={'Add number'}
                        dark
                        onPress={() => this.handleAddRow(versionKey)}
                      />
                      <TouchableOpacity
                        onPress={() => this.deleteVersion(versionKey)}
                      >
                        <Image source={trashIcon} style={{...K.defaultIconSize, opacity: 0.5}} />
                      </TouchableOpacity>
                    </View>
                  </View>
                );
              })}
              <Button
                label={'Add version'}
                dark
                style={{}}
                onPress={this.createProductOptionClassifierNumbersVersion}
              />
            </LabelledView>
            <Button
              light
              style={{marginTop: K.spacing}}
              onPress={this.handleDelete}
              label={'DELETE'}
            />
          </View>
        )}
      </Popup>
    );
  }
}

export default connect({
  mapState: (state, ownProps) => {
    return {};
  },
  mapDispatch: {
    ..._.pick(resourceActions.productOptionClassifiers, ['updateProductOptionClassifier']),
  }
})(ProductOptionClassifierPopup);
